import RenderIf from "common/components/RenderIf";
import { Button } from "common/components/ui/Button";

import EditButton from "./EditButton";
import { useFlowTemplateContext } from "./FlowTemplateContext";
import RemoveButton from "./RemoveButton";
import TemplateSelect from "./TemplateSelect";

import type { JSX } from "react";

interface DesktopLayoutProps {
  actionDelayComponent: JSX.Element;
  templatePreviewComponent: JSX.Element;
  templateEditorComponent: JSX.Element;
}

export default function DesktopLayout({
  templateEditorComponent,
  actionDelayComponent,
  templatePreviewComponent,
}: DesktopLayoutProps) {
  const { isEditing, handleSave, handleDiscard } = useFlowTemplateContext();

  return (
    <>
      <RenderIf condition={!!actionDelayComponent}>
        {actionDelayComponent}
      </RenderIf>
      <div className="grid grid-cols-2 gap-2">
        {/* TemplateDetails */}
        <div className="flex flex-1 flex-col">
          <div className="mb-2 flex items-center gap-2.5">
            <TemplateSelect />
            {isEditing ? (
              <div className="flex items-center gap-2">
                <Button variant="outline-black" onClick={handleDiscard}>
                  Discard
                </Button>
                <Button variant="secondary-purple" onClick={handleSave}>
                  Save
                </Button>
              </div>
            ) : (
              <EditButton />
            )}
          </div>

          {templateEditorComponent}
        </div>

        {/* Preview */}
        {templatePreviewComponent}
      </div>

      <RemoveButton />
    </>
  );
}
